import { createIcon } from '../create-icon'

// Coins/gold — resource acquisition and farming efficiency
export const GpiFarming = createIcon('GpiFarming', ({ strokeWidth }) => (
  <>
    <circle cx="8" cy="8" r="6" strokeWidth={strokeWidth} />
    <path d="M18.09 10.37A6 6 0 1 1 10.34 18" strokeWidth={strokeWidth} />
    <path d="M7 6h1v4" strokeWidth={strokeWidth} />
    <path d="m16.71 13.88.7.71-2.82 2.82" strokeWidth={strokeWidth} />
  </>
))
